import { useState, useEffect } from '@wordpress/element';
import { OpeningTimeDuration } from './components/opening-time-duration/opening-time-duration';
import { OpeningTimePeriod } from './components/opening-time-period/opening-time-period';
import './opening-time-page.scss';
import { Schedule } from '../../core/models/schedule';
import { getScheduleData, updateSchedule } from '../../core/services/schedule.service';
import { Loading } from '../../components/loading/loading';
import { t } from 'i18next';
import { SettingsHeader } from '../../components/layout/settings-header/settings-header';
import { notification } from 'antd';

export const OpeneingTimesPage: React.FC = () => {
	const [loading, setLoading] = useState(true);
	const [schedule, setSchedule] = useState<Schedule[]>([]);
	const [api, contextHolder] = notification.useNotification();

	useEffect(() => {
		const loadSchedule = async () => {
			try {
				const fetchedSchedule = await getScheduleData();
				const updatedSchedule: Schedule[] = fetchedSchedule.map((entry) => ({
					...entry,
					startTime: entry.startTime,
					endTime: entry.endTime,
					enbaled: entry.enabled,
				}));
				setSchedule(updatedSchedule);
			} catch (error) {
				console.error('Error loading schedule:', error);
			} finally {
				setLoading(false);
			}
		};

		loadSchedule();
	}, []);

	const onSaveOpeningTimes = async () => {
		try {
			await updateSchedule(schedule);

			api['success']({
				message: t('backEnd.saveSettings'),
			});
		} catch (error: any) {
			api.error({
				message: 'Error occured',
				description: error?.message,
			});
		}
	};

	return (
		<Loading isLoading={loading}>
			{contextHolder}
			<div className='opening-time-page-container'>
				<SettingsHeader title={t('backEnd.openingTime.headline')} onClickSave={onSaveOpeningTimes} />
				<OpeningTimePeriod schedule={schedule} onChangeSchedule={setSchedule} />
				<OpeningTimeDuration schedule={schedule} onChangeSchedule={setSchedule} />
			</div>
		</Loading>
	);
};
